import React from 'react';
import PropTypes from 'prop-types';
import Canvas from './Canvas';
import ThreeEngine from './Three';

const propTypes = {
    engine: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
        PropTypes.object,
    ]),
};

const defaultProps = {
    engine: ThreeEngine,
};

const CanvasThree = props => (
    <Canvas {...props} />
);

CanvasThree.propTypes = propTypes;
CanvasThree.defaultProps = defaultProps;

export default CanvasThree;



// WEBPACK FOOTER //
// ./vendor/react-draw/CanvasThree.jsx